import { registerBlockType, getBlockType } from '@wordpress/blocks';
import { useBlockProps } from '@wordpress/block-editor';
import ServerSideRender from '@wordpress/server-side-render';

if(!getBlockType('preciseinvestigation/custom-header')) {
    registerBlockType('preciseinvestigation/custom-header', {
        title: 'preciseinveatigationCustom Header',
        icon: 'layout',
        category: 'preciseinvestigation-blocks',
        edit: (props) => editComponent(props),
        save: (props) => saveComponent(props),
    });
}

function editComponent() {
    const blockProps = useBlockProps();
    return (
      <div { ...blockProps }>
        <ServerSideRender block="preciseinvestigation/custom-header" />
      </div>
    );
}

function saveComponent() {
    return null;
}